import axios from 'axios';

const API_BASE_URL = 'https://data.nadzor.app/api/admin_panel/gallery'; // Replace with your backend's URL

export const createAlbum = async (userId, name) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/addAlbum.php`, {
      user_id: userId,
      name,
    });
    if (response.data.status === 200) {
      return response.data.album; // Return the newly created album
    } else {
      console.error('Error creating album:', response.data.message);
      return null;
    }
  } catch (error) {
    console.error('Error creating album:', error);
    return null;
  }
};

// Fetch all albums for a specific user
export const fetchAlbums = async (userId) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/getAlbums.php`, {
      user_id: userId,
    });

    if (response.data.status === 200) {
      return response.data.albums; // Return the array of albums
    } else {
      console.error(response.data.message);
      return [];
    }
  } catch (error) {
    console.error('Error fetching albums:', error.message || error);
    return [];
  }
}

